// extracted by mini-css-extract-plugin
export default {"root":"SettingsCard_root__3Vsxq"};